/**
 * The event page's own lookup. lib/catalog.js's fetchEvent() collapses "withdrawn", "purged" and "never existed"
 * into one `none`, which is right for the share view (they all fall back to the landing) and wrong for a page
 * that has to say "this event has ended" for one and "we could not find it" for another.
 *
 * Kinds: event · redirect · tombstone · missing · unavailable. A 503 is `unavailable`, never `missing`, so a blip
 * never replaces a good page with a not-found. Same endpoint, same media-proxied payload.
 */
import { API_BASE } from "./catalog";
import { isSlug } from "./gate";

export async function fetchEventDetail(slug, fetcher = (...a) => window.fetch(...a)) {
  if (!isSlug(slug)) return { kind: "missing" };
  let res;
  try {
    res = await fetcher(`${API_BASE}/event/${encodeURIComponent(slug)}`, { headers: { Accept: "application/json" } });
  } catch {
    return { kind: "unavailable" };
  }
  if (res.status === 404) return { kind: "missing" };
  if (!res.ok) return { kind: "unavailable" };
  let body;
  try {
    body = await res.json();
  } catch {
    return { kind: "unavailable" };
  }
  if (body && typeof body.redirect_to === "string" && isSlug(body.redirect_to) && body.redirect_to !== slug) {
    return { kind: "redirect", slug: body.redirect_to };
  }
  if (body && (body.gone === true || body.visibility === "withdrawn")) return { kind: "tombstone" };
  if (body && body.slug && Array.isArray(body.event_sessions) && (body.visibility === "public" || body.visibility === "unlisted")) {
    return { kind: "event", event: body };
  }
  return { kind: "missing" };
}
